import styled from "styled-components";

export const StyledMatchListHeader = styled.div`
  margin-top: 24px;
  margin-bottom: 8px;
`;

export const StyledMatchListHeaderTimezone = styled.span``;

export const StyledMatchListHeaderDate = styled.h2`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_headline};
  font-weight: 700;
  font-size: ${(props) => props.theme.mixins.pxToRem(17)};
  line-height: 20px;
  color: rgba(45, 45, 45, 1);
`;
